import { useState } from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { ModalMap } from '../../../../components/modalMap/ModalMap';

export const LocationComponent = ({ field }) => {
  const [isOpenMapModal, setIsOpenMapModel] = useState(false);
  const { translate: t } = useDictionaryTranslation();

  const openMapModal = () => {
    setIsOpenMapModel(true);
  };
  const closeMapModal = () => {
    setIsOpenMapModel(false);
  };

  return (
    <>
      <p>
        {field?.value?.address ? (
          <>
            {field.value.address} -{' '}
            <Button style={{ padding: 0 }} type="link" onClick={openMapModal}>
              {t('showLocation')}
            </Button>
          </>
        ) : null}
      </p>
      <ModalMap
        title={field.label}
        show={isOpenMapModal}
        handleClose={closeMapModal}
        coordsInfo={{
          value: {
            markerCoords: field?.value?.markerCoords,
          },
        }}
      />
    </>
  );
};

LocationComponent.propTypes = {
  field: PropTypes.shape({
    label: PropTypes.string,
    idInput: PropTypes.string,
    value: PropTypes.shape({
      address: PropTypes.string,
      markerCoords: PropTypes.string,
    }),
  }),
};
